import React from "react"
import { Title } from ".."
import { FaAngleDoubleRight } from "react-icons/fa"
import { graphql, useStaticQuery } from "gatsby"
import { Link } from "gatsby"
import styled from "styled-components"
const query = graphql`
  {
    allStrapiJobs(sort: { fields: strapiId, order: DESC }) {
      nodes {
        strapiId
        company
        date
        position
        desc {
          id
          name
        }
      }
    }
  }
`

const Jobs = () => {
  const data = useStaticQuery(query)
  const {
    allStrapiJobs: { nodes: jobs },
  } = data
  const [value, setValue] = React.useState(1)
  const { company, position, date, desc } = jobs[value]
  return (
    <Container className="section jobs">
      <Title title="experience" />

      <div className="jobs-center">
       
        <ButtonContainer>
          {jobs.map((item, index) => {
            return (
              <Button
                key={item.strapiId}
                onClick={() => setValue(index)}
                active= {index === value }
              >
               {item.company}
              </Button>
            )
          })}
        </ButtonContainer>
        {/* job info */}
        <article className="job-info">
          <h3>{position}</h3>
          <Company>{company}</Company>
          <p className="job-date">{date}</p>
          {desc.map(item => {
            return (
              <div key={item.id} className="job-desc">
                <FaAngleDoubleRight className="job-icon"></FaAngleDoubleRight>
                <p>{item.name}</p>
              </div>
            )
          })}
        </article>
      </div>
      <Link to="/about" className="btn center-btn">
        Portfolio
      </Link>
    </Container>
  )
}

export default Jobs

export const Container = styled.section`
  background: ${({ theme }) => theme.body};
  padding: 5rem 0;
`

export const Company = styled.h4`
color:${({ theme }) => theme.headerColor};

`
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 4rem;

  @media screen and (min-width: 992px) {
    flex-direction: column;
    justify-content: flex-start;

  }
`
export const Button = styled.button`
  background: transparent;
  border-color: transparent;
  text-transform: capitalize;
  font-size: 1.25rem;
  letter-spacing: var(--spacing);
  margin: 0 0.5rem;
  transition: var(--transition);
  cursor: pointer;
  padding: 0.25rem 0;
  line-height: 1;

  &:hover{
  color: var(--clr-primary-5);
  box-shadow: 0 2px var(--clr-primary-5);

  @media screen and (min-width: 992px) {
    box-shadow: -2px 0 var(--clr-primary-5);
  }
  }

  color: ${({ theme,active}) => !active ? theme.headerColor:'var(--clr-primary-5)'} ;
  box-shadow:  ${({ active}) => active && '-3px 0 var(--clr-primary-5)'};


  @media screen and (min-width: 992px) {
    margin-bottom: 1rem;

  }
`

